import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("referu_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setSubscription(data.subscription);
    } catch (e) {
      setUser(false);
      localStorage.removeItem("referu_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("referu_token", data.token);
    setUser(data.user);
    setSubscription(data.subscription);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("referu_token", data.token);
    setUser(data.user);
    setSubscription(data.subscription);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("referu_token");
    setUser(false);
    setSubscription(null);
    window.location.href = "/login";
  };

  const refreshSubscription = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setSubscription(data.subscription);
    } catch (e) {}
  };

  return (
    <AuthContext.Provider value={{ user, subscription, loading, login, register, logout, setUser, refreshSubscription }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
